import { c as _c } from "react/compiler-runtime";
import { Box, Container, Link as MuiLink, Typography } from "@mui/material";
import Link from "next/link";
import React from "react";
import { useOptionalCookieConsentContext } from "#/features/cookieConsent/context/CookieConsentContext";
import { useI18nContext } from "#/shared/hooks";
export const Footer: React.FC = () => {
  const $ = _c(12);
  const {
    LL
  } = useI18nContext();
  const cookieConsent = useOptionalCookieConsentContext();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mt: 4,
      mb: 2,
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 2
    };
    t1 = <Typography variant="caption">© Max Kayander, 2026.</Typography>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== LL) {
    t2 = LL.PRIVACY_POLICY();
    $[2] = LL;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <MuiLink component={Link} href="/privacy" variant="caption" underline="hover" color="text.secondary">{t2}</MuiLink>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== LL || $[7] !== cookieConsent) {
    t4 = cookieConsent ? <MuiLink component="button" type="button" variant="caption" underline="hover" color="text.secondary" onClick={cookieConsent.openCookieSettings} sx={{
      background: "none",
      border: 0,
      cursor: "pointer",
      font: "inherit",
      p: 0
    }}>{LL.COOKIE_SETTINGS_LINK()}</MuiLink> : null;
    $[6] = LL;
    $[7] = cookieConsent;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Container component="footer"><Box sx={t0}>{t1}{t3}{t4}</Box></Container>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};